import { useTranslation } from 'react-i18next';
import { TriangleAlert } from 'lucide-react';
import { NoticeCard } from '@/presentation/component/ui';
import { noticeIconClass } from '@/presentation/component/course/noticeStyles';

export const MediaErrorNotice = () => {
  const { t } = useTranslation();

  return (
    <NoticeCard
      icon={<TriangleAlert className={noticeIconClass} />}
      title={t('coursePlayer.mediaLoadError')}
      description={t('coursePlayer.mediaLoadErrorDesc')}
    />
  );
};
